module.exports = __webpack_public_path__ + "aa2c29a493a5727f9f6e54c8b2c90752.pdf";